import { Snackbar, Typography } from '@mui/material';
import React from 'react';

const snackbarStyle = {
  height: '50px',
  borderRadius: '50px',
  overflow: 'hidden',
  '&>.MuiPaper-root': {
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'none',
    backgroundColor: 'none',
  },
};

const CustomSnackBar = ({
  shouldOpen,
  handleCloseSnackBar,
  text,
  width = '150px',
  isError = false,
}: any) => {
  return (
    <Snackbar
      sx={{
        ...snackbarStyle,
        width,
        background: isError ? '#DC3551' : '#362F2F',
      }}
      autoHideDuration={2000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={shouldOpen}
      onClose={handleCloseSnackBar}
      message={<Typography variant="body1">{text}</Typography>}
    />
  );
};

export default CustomSnackBar;
